import { EntityService } from '../../../service/EntityService';

export class ProductService extends EntityService {

  static entity = 'api/app/product';
  static updateChangeTax(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/change-tax`, data).then(res => res.data);
  }
}
export class StampService extends EntityService {

  static entity = 'api/app/stamp';
  static uploadTemplate(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload`, data).then(res => res.data);
  }
}
